
	import { defineComponent, ref, computed, onMounted, inject } from 'vue';
	import { useRoute } from 'vue-router';
	import { getLyraEndpoints } from '@/core/modules/lyra/services';
	import { ILyraObject } from '@/core/modules/lyra/@types';

	export default defineComponent({
		setup() {
			/**
			 * Endpoint
			 */
			const route = useRoute();
			const endpointId = computed((): any => {
				return route.params.endpointId;
			})
			const sectionId = computed((): any => {
				return route.params.sectionId;
			})

			/**
			 * Content from Lyra
			 */
			const content = ref('');
			onMounted(async () => {
                await queryData();
            })

			async function queryData () {
				const $lyra: ILyraObject = await inject<ILyraObject>('$lyra') as ILyraObject;
				const sections = getLyraEndpoints('sections');
				const currentSection: any = sections.find((_: any) => _.endpointId === sectionId.value);
				const tierId = currentSection.endpoints;

				const response = await $lyra.endpoints({
					tierId,
					endpointId: endpointId.value,
				});

				if (!response.success) { return; }

				const { data } = response;
				const [record] = data;

				content.value = record.content;
			}

			return { endpointId, content }
		}
	})
